export default __webpack_public_path__ + "static/media/shop1.7e959fe4.mp4";